import type { ReactNode } from 'react';
import type { PerformanceTabData } from '../data/api';
import { FeatureColumns, type FeatureItem } from '../shared/FeatureColumns';

type ElementGroup = PerformanceTabData['elements'][number];

export function FailurePatterns({ elements }: { elements: ElementGroup[] }): ReactNode {
  const columns = Object.fromEntries(
    elements.map((group): [string, FeatureItem[]] => [
      group.category,
      group.features.map((item) => ({ label: item.feature, value: item.tags.join(', ') })),
    ]),
  );
  return <FeatureColumns title="Failure Patterns" tone="error" columns={columns} />;
}
